module.exports = __webpack_public_path__ + "static/img/clothing_13.4651077.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_13.png
// module id = Q01I
// module chunks = 0